import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { SessionService } from './session.service';
import { _common } from './_common';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset.password.check.component.html',
    standalone: true,
    imports: [NgIf, MatLegacyFormFieldModule, MatLegacyInputModule, ReactiveFormsModule, FormsModule, MatLegacyButtonModule]
})
export class ResetPasswordCheckComponent implements OnInit {

  _common = _common;

  token: string;
  email: string = '';
  password: string = '';
  password2: string = '';
  error: string;
  subscription: Subscription;
  subscription1: Subscription;

  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
  ) {

  }
  app: string


  ngOnInit() {

    this.subscription = this.route.queryParams.subscribe((params) => {

      this.app = params.app;
      SessionService.fixTitle(this.app);

    })

    this.subscription1 = this.route.paramMap.subscribe((paramMap) => {
      this.token = paramMap.get('token');
      this.email = paramMap.get('email');


      this.http.post('/ext/signup/reset_password_check', { token: this.token, email: this.email }).subscribe((data: any) => {
        if (!data.succeed) {
          this.router.navigate(['/error']);
          return;
        }
      }, (error) => {

        this.router.navigate(['/error']);

      });
    });

  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscription1.unsubscribe();
  }

  proceed() {


    if (this.password != this.password2) {
      this.error = "Password do not match";
      return;

    }
    this.http.post('/ext/signup/reset_password_update', {
      email: this.email,
      token: this.token,
      password: this.password,

    }).subscribe((data: any) => {

      if (!data.succeed) {
        this.router.navigate(['/error']);

        return;

      }

      this.router.navigate(['/reset_password_updated'], {
        queryParams: {
          app: this.app
        }
      });

    }, (error) => {
      this.router.navigate(['/error']);

    });
  }

}
